import { render, staticRenderFns } from "./almacen-salidas.vue?vue&type=template&id=32861a24&"
import script from "./almacen-salidas.vue?vue&type=script&lang=js&"
export * from "./almacen-salidas.vue?vue&type=script&lang=js&"
import style0 from "./almacen-salidas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports